<template>
    <div class="row button-question">
        <div class="col-10 question" v-html="label">
        </div>
        <div class="col-2 question-error">
          {{errors}}
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import LabelFilledMixin from './LabelFilledPlaceholdersComputedMixin'

export default {
  name: 'OnlyLabel',
  props: ['question', 'modelValue', 'errors', 'allowChange'],
  mixins: [LabelFilledMixin],
  emits: ['update:modelValue'],
  data () {
    return {
      values: []
    }
  },
  computed: {
    ...mapGetters({
      leadInfo: 'consumer/lead/leadInfo'
    })
  },
  methods: {
  },
  mounted () {
  },
  watch: {
  }
}
</script>
